import type { CustomIconProps } from '../types';

const HalfEmptyStar = ({ width, height }: CustomIconProps): JSX.Element => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ?? '16'}
        height={height ?? '16'}
        viewBox="0 0 16 16"
        fill="none"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 0L10.2249 5.62464L16 6.11146L11.6 10.0745L12.9443 16L8 12.8246L3.05573 16L4.4 10.0745L0 6.11146L5.77508 5.62464L8 0ZM9.28915 6.884L12.8198 7.18162L10.1267 9.60719L10.9231 13.1175L8 11.2402V3.625L9.28915 6.884Z"
            fill="#414042"
        />
    </svg>
);

export default HalfEmptyStar;
